<template>
  <v-dialog
    content-class="stay-control-quiz-dialog"
    :value="true"
    :transition="false"
    @click:outside="closeCustomQuizDialog"
    @keydown.esc="closeCustomQuizDialog"
  >
    <v-card>
      <v-container class="stay-control-quiz-dialog-container">
        <v-card-text class="pa-0 stay-control-quiz-dialog-title">
          <div class="crying-icon-container">
            <crying-face-icon
            class="crying-icon"
            />
          </div>
          <div>
            {{ $t('dialogs.exit.title') }}
          </div>
        </v-card-text>
        <v-btn
          icon
          width="fit-content"
          height="fit-content"
          class="stay-control-quiz-dialog-close-button"
          @click="closeCustomQuizDialog"
        >
          <close-icon class="stay-control-quiz-dialog-close-icon" />
        </v-btn>
      </v-container>
      <v-container class="ma-0 stay-control-quiz-dialog-container-text">
        <div class="custom-stay-control-quiz-dialog-body-text">
         {{ $t('dialogs.exit.description1') }}
        </div>
        <div class="custom-stay-control-quiz-dialog-body-text">
          {{ $t('dialogs.exit.description2') }}
        </div>
      </v-container>
      <v-card-actions class="d-flex stay-control-quiz-dialog-container-footer">
        <v-btn
          class="custom-stay-control-quiz-dialog-contact-quiz-btn px-8 py-0"
          color="button-primary-background-default"
          height="48"
          @click="closeCustomQuizDialog"
        >
          <span class="custom-stay-control-quiz-dialog-contact-quiz-btn-txt">
            {{ $t('dialogs.exit.continue') }}
          </span>
        </v-btn>
        <v-btn
          class="custom-stay-control-quiz-exit-btn"
          elevation="0"
          block
          @click="closeDialog"
        >
          <span class="quiz-exit-btn-text">
            {{ $t('dialogs.exit.exit') }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CloseIcon from '@/assets/svgIcons/closeIcon.svg?inline'
import CryingFaceIcon from '@/assets/quiz/cryingFace.svg?inline'
export default {
  name: 'DialogQuizExit',
  components: {
    CloseIcon,
    CryingFaceIcon
  },

  methods: {
    closeCustomQuizDialog () {
      this.$store.dispatch('main/closeDialog', 'quizLeavePrompt')
    },
    closeDialog () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.crying-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
}

.stay-control-quiz-dialog {
  border-radius: 16px;
  width: 620px;
}

.custom-stay-control-quiz-dialog-contact-quiz-btn-txt {
  color: var(--v-button-primary-foreground-default-base);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-transform: none;
  letter-spacing: 0;
}

.stay-control-quiz-dialog-container {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 40px 40px 16px;
}

.stay-control-quiz-dialog-container-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 40px;
}

.stay-control-quiz-dialog .v-card__actions.stay-control-quiz-dialog-container-footer {
  padding: 24px 40px 40px 40px;
}

.custom-stay-control-quiz-dialog-body-text {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: var(--v-text-primary-base);
  font-family: Roboto,serif;

}

.custom-stay-control-quiz-dialog-contact-quiz-btn {
  box-shadow: unset;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: start;
  gap: 8px;
  border-radius: 8px;
  letter-spacing: normal;
}

.stay-control-quiz-dialog-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: var(--v-text-primary-base);
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: normal;
  font-family: Roboto,serif;
}

.stay-control-quiz-dialog-close-button {
  fill: var(--v-old-icon-button-outline-secondary-foreground-default-base);
  right: 16px;
  padding: 5px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 16px;
}

.stay-control-quiz-dialog-close-icon {
  width: 24px;
  height: 24px;
  color: var(--v-button-secondary-gray-foreground-default-base);
}

.v-sheet .v-card__actions .custom-stay-control-quiz-exit-btn {
  height: 48px;
  padding: 16px 32px;
  max-width: 140px;
  min-width: unset!important;
  background-color: transparent;
  border-radius: 8px;
  letter-spacing: normal;
}

.quiz-exit-btn-text {
  color: var(--v-secondary-button-tertiary-foreground-default-base);
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-transform: none;
}

@media (max-width: 1200px) {
  .stay-control-quiz-dialog-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
  }

  .crying-icon {
    width: 24px;
    height: 24px;
  }

  .crying-icon-container {
    margin-right: 12px;
  }

  .stay-control-quiz-dialog {
    width: 343px;
  }

  .stay-control-quiz-dialog-container {
    padding: 20px 24px 12px 24px;
  }

  .stay-control-quiz-dialog-container-text {
    padding: 0 24px;
  }

  .stay-control-quiz-dialog .v-card__actions.stay-control-quiz-dialog-container-footer {
    padding: 16px 24px 20px 24px;
  }
}
</style>
